/**
 * Longest sidebar path that matches `pathname`.
 * Exact match, or a parent prefix (`/ops/sales/orders` → `/ops/sales/orders/123`).
 * A shorter path such as `/ops` loses to any longer registered path, so the
 * home item does not stay selected on every Ops screen.
 */
export function bestMatchingNavPath(
  pathname: string,
  paths: readonly string[],
): string | null {
  let best: string | null = null;
  for (const itemPath of paths) {
    if (!itemPath) continue;
    const exact = pathname === itemPath;
    const prefix = itemPath !== "/" && pathname.startsWith(`${itemPath}/`);
    if (!exact && !prefix) continue;
    if (best === null || itemPath.length > best.length) best = itemPath;
  }
  return best;
}

/** `NavLink end`: exact-only when another item lives under this path. */
export function navLinkShouldEnd(
  itemPath: string,
  paths: readonly string[],
): boolean {
  const prefix = `${itemPath}/`;
  return paths.some((p) => p !== itemPath && p.startsWith(prefix));
}
